var _defs, _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f3f5;}.cls-2{fill:url(#New_Gradient_Swatch_copy_3);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#New_Gradient_Swatch_copy_3-2);}.cls-5{fill:url(#New_Gradient_Swatch_copy_3-3);}.cls-6{fill:url(#New_Gradient_Swatch_copy_3-4);}.cls-7{fill:url(#New_Gradient_Swatch_copy_3-5);}.cls-8{fill:url(#New_Gradient_Swatch_copy_3-6);}.cls-9{fill:url(#New_Gradient_Swatch_copy_3-7);}.cls-10{fill:url(#New_Gradient_Swatch_copy_3-8);}.cls-11{fill:url(#New_Gradient_Swatch_copy_3-9);}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3",
    x1: 395.7558,
    y1: 178.3106,
    x2: 395.7558,
    y2: 199.2857,
    gradientTransform: "translate(582.6344 -207.8677) rotate(89.7224)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2507,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9049
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2712
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 395.4521,
    y1: 337.1397,
    x2: 395.4521,
    y2: 318.4317,
    gradientTransform: "translate(2.7624 -3.3043) rotate(0.4804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1213,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9049
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2712
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-2",
    x1: 176.3124,
    y1: 344.8508,
    x2: 314.7563,
    y2: 240.5258,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-3",
    x1: 258.9804,
    y1: 176.1177,
    x2: 318.7812,
    y2: 176.1177,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-4",
    x1: 259.0615,
    y1: 205.043,
    x2: 326.1748,
    y2: 205.043,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-5",
    x1: 259.0615,
    y1: 234.6182,
    x2: 318.7812,
    y2: 234.6182,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-6",
    x1: 259.0615,
    y1: 265.4932,
    x2: 318.7812,
    y2: 265.4932,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-7",
    x1: 259.0615,
    y1: 294.4185,
    x2: 318.6992,
    y2: 294.4185,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-8",
    x1: 348.2939,
    y1: 172.0117,
    x2: 348.2939,
    y2: 138.5239,
    gradientTransform: "translate(502.3336 -193.571) rotate(89.7981)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-9",
    x1: -7248.077,
    y1: -1528.3145,
    x2: -7248.077,
    y2: -1561.211,
    gradientTransform: "translate(-6883.4589 -1339.7913) rotate(179.7914)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 397.0527,
    y1: 200.3731,
    x2: 397.0527,
    y2: 314.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3917,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7691
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#f5f3f5",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8895,
    stopColor: "#f5f3f5",
    stopOpacity: 0.1312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 397.0527,
    y1: 236.0357,
    x2: 397.0527,
    y2: 278.376,
    xlinkHref: "#linear-gradient-2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 393.8114,
    y: 172.0385,
    width: 3.961,
    height: 8.8694,
    transform: "translate(216.4038 570.9525) rotate(-89.5773)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 385.2896,
    y: 184.3635,
    width: 20.9324,
    height: 8.8692,
    transform: "translate(205.0426 583.6346) rotate(-89.7224)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 391.0174,
    y: 318.4684,
    width: 8.8695,
    height: 18.6344,
    transform: "translate(-2.7346 3.3274) rotate(-0.4804)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "400.023 346.631 232.45 346.631 232.45 123.796 241.319 123.796 241.319 337.761 391.096 337.761 391.092 337.025 399.961 336.969 400.023 346.631"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.863 180.809 349.353 133.103 238.424 133.103 238.424 124.232 353.209 124.232 400.35 174.758 393.863 180.809"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "354.635 182.972 343.8 182.972 343.8 171.166 352.669 171.166 352.669 174.102 354.635 174.102 354.635 182.972"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "385.024 376.204 199.938 376.204 200.276 138.164 237.899 138.533 237.811 147.402 209.134 147.121 208.821 367.334 376.038 367.334 375.771 346.78 384.641 346.665 385.024 376.204"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.9804,
    y: 171.6826,
    width: 59.8008,
    height: 8.8701
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 259.0615,
    y: 200.6079,
    width: 67.1133,
    height: 8.8701
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 259.0615,
    y: 230.1831,
    width: 59.7197,
    height: 8.8701
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 259.0615,
    y: 261.0581,
    width: 59.7197,
    height: 8.8701
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 259.0615,
    y: 289.9834,
    width: 59.6377,
    height: 8.8701
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 331.5655,
    y: 150.8332,
    width: 33.4568,
    height: 8.8692,
    transform: "translate(191.7999 503.0125) rotate(-89.7981)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 365.7582,
    y: 162.1452,
    width: 8.8702,
    height: 32.8635,
    transform: "translate(190.27 548.1177) rotate(-89.7914)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M397.0527,314.0386a41.1427,41.1427,0,0,1-7.1279-.4917,9.09,9.09,0,0,1-7.5625-6.8369c-.4571-1.6387-1.0635-3.91-1.6719-6.1861s-1.2158-4.5537-1.6738-6.1972a5.17,5.17,0,0,0-.9619-1.8223l-.0538-.041a8.2239,8.2239,0,0,0-.8964-.6533l-.045-.0254a8.3049,8.3049,0,0,0-1.0146-.45l-.1123-.0449a5.3745,5.3745,0,0,0-2.0117.0971c-1.6328.42-3.8809,1.0244-6.1309,1.6294-2.2988.6182-4.6,1.2368-6.2705,1.6665a9.0982,9.0982,0,0,1-9.7022-3.14,51.8444,51.8444,0,0,1-7.122-12.3394,9.0939,9.0939,0,0,1,2.1367-9.9668c1.1963-1.2192,2.8652-2.8857,4.5371-4.5542,1.6621-1.66,3.3262-3.3208,4.5176-4.5361a5.1612,5.1612,0,0,0,1.0967-1.7451l.0068-.0562a8.3739,8.3739,0,0,0,.12-1.1132,8.2547,8.2547,0,0,0-.12-1.1661l-.0146-.102a5.35,5.35,0,0,0-1.09-1.6987c-1.19-1.2144-2.8545-2.876-4.5166-4.5352-1.6719-1.6685-3.3408-3.335-4.5391-4.5571a9.0947,9.0947,0,0,1-2.1308-9.9741,51.9047,51.9047,0,0,1,7.124-12.3365,9.0933,9.0933,0,0,1,9.7012-3.1318c1.6611.4272,3.9521,1.0435,6.2441,1.66,2.2569.6069,4.5147,1.2138,6.1553,1.6362a5.1566,5.1566,0,0,0,2.0586.0767l.0586-.0245a8.3246,8.3246,0,0,0,1.0185-.4511,8.184,8.184,0,0,0,.9444-.6812l.0869-.07a5.34,5.34,0,0,0,.9258-1.792c.457-1.64,1.0644-3.9141,1.6709-6.1851.6093-2.28,1.2168-4.5561,1.6757-6.2031a9.0943,9.0943,0,0,1,7.5713-6.833,51.9711,51.9711,0,0,1,14.2461.0015,9.0914,9.0914,0,0,1,7.5625,6.8374c.4639,1.6611,1.0821,3.9751,1.6983,6.2842.6,2.2421,1.1972,4.48,1.6484,6.1a5.161,5.161,0,0,0,.9609,1.8208l.0518.039a8.1469,8.1469,0,0,0,.8984.6558,8.2608,8.2608,0,0,0,1.0625.4765l.1065.042a5.3554,5.3554,0,0,0,2.0146-.0952c1.6407-.4219,3.9034-1.0307,6.1651-1.6387,2.2871-.6147,4.5732-1.2294,6.2353-1.6572a9.0971,9.0971,0,0,1,9.7032,3.14,51.8563,51.8563,0,0,1,7.122,12.3388,9.0915,9.0915,0,0,1-2.1386,9.9678c-1.1944,1.2187-2.8633,2.8852-4.5352,4.5537-1.6621,1.6592-3.3262,3.3208-4.5166,4.5356a5.155,5.155,0,0,0-1.0977,1.7452l-.01.0771a5.4076,5.4076,0,0,0-.001,2.2354l.0195.1323a5.3951,5.3951,0,0,0,1.09,1.6929c1.1894,1.2133,2.8535,2.8745,4.5156,4.5341,1.6719,1.6685,3.3408,3.335,4.5391,4.5567a9.0951,9.0951,0,0,1,2.1308,9.9746,51.8852,51.8852,0,0,1-7.124,12.3359,9.095,9.095,0,0,1-9.7022,3.1319c-1.6621-.4278-3.957-1.045-6.2529-1.6617-2.2539-.6059-4.5068-1.2119-6.1455-1.6337a5.1668,5.1668,0,0,0-2.0586-.0772l-.0625.0259a8.3049,8.3049,0,0,0-1.0146.45,8.0839,8.0839,0,0,0-.9414.6787l-.0928.0732a5.3725,5.3725,0,0,0-.9229,1.7906c-.4511,1.6211-1.05,3.8637-1.65,6.11-.6152,2.3052-1.2324,4.6143-1.6962,6.28a9.0934,9.0934,0,0,1-7.5713,6.8316A41.1155,41.1155,0,0,1,397.0527,314.0386Zm-5.9824-9.32a.79.79,0,0,0,.2451.0683,43.2975,43.2975,0,0,0,11.4648.0015.7557.7557,0,0,0,.26-.0737h0a1.1114,1.1114,0,0,0,.1563-.3736c.4589-1.6474,1.0664-3.9218,1.6728-6.1928.6094-2.28,1.2168-4.5562,1.6758-6.2032a13.2036,13.2036,0,0,1,3.9531-6.3564l.1026-.0806a13.9073,13.9073,0,0,1,4.1855-2.4165l.1055-.042a13.2052,13.2052,0,0,1,7.498-.2544c1.6651.4287,3.9531,1.0435,6.2412,1.6587,2.2608.6079,4.5225,1.2158,6.1641,1.6387a1.0511,1.0511,0,0,0,.4141.0513.7876.7876,0,0,0,.1826-.1792,43.3277,43.3277,0,0,0,5.7334-9.9273.7736.7736,0,0,0,.0664-.2627h0a1.1149,1.1149,0,0,0-.2471-.3227c-1.1826-1.2066-2.8281-2.8487-4.4746-4.4922-1.6875-1.6846-3.376-3.3711-4.585-4.6045a13.2113,13.2113,0,0,1-3.5283-6.6l-.0215-.147a15.67,15.67,0,0,1-.209-2.4287,15.4263,15.4263,0,0,1,.21-2.3779l.0176-.1221a13.2118,13.2118,0,0,1,3.53-6.6221c1.2089-1.2343,2.8984-2.9209,4.5859-4.6054,1.6465-1.6436,3.291-3.2857,4.4717-4.49a1.0439,1.0439,0,0,0,.2509-.3315h0a.7988.7988,0,0,0-.0634-.2471,43.2794,43.2794,0,0,0-5.7315-9.9292.7622.7622,0,0,0-.1943-.189v0a1.1093,1.1093,0,0,0-.4033.0518c-1.6416.4223-3.8936,1.0283-6.1475,1.6343-2.2949.6171-4.5918,1.2343-6.26,1.6635a13.21,13.21,0,0,1-7.4814-.2456l-.1152-.0464a15.7533,15.7533,0,0,1-2.2286-1.0405,15.5811,15.5811,0,0,1-1.9736-1.3852l-.083-.065a13.202,13.202,0,0,1-3.9648-6.3642c-.459-1.6465-1.0655-3.918-1.6739-6.1939s-1.2158-4.5537-1.6738-6.1973a1.0476,1.0476,0,0,0-.1631-.3847h0a.7913.7913,0,0,0-.2451-.0684,43.36,43.36,0,0,0-11.4648-.0014.7611.7611,0,0,0-.26.0737h0a1.11,1.11,0,0,0-.1563.374c-.4531,1.6284-1.0517,3.8711-1.6523,6.1172-.6152,2.3052-1.2324,4.6143-1.6963,6.28a13.2027,13.2027,0,0,1-3.9531,6.355l-.0957.0757a13.92,13.92,0,0,1-4.2012,2.4252l-.1.04a13.2158,13.2158,0,0,1-7.4951.2534c-1.668-.4292-3.959-1.0454-6.251-1.6616-2.2568-.6069-4.5146-1.2139-6.1553-1.6362a1.0346,1.0346,0,0,0-.413-.0508.8058.8058,0,0,0-.1827.1792,43.3351,43.3351,0,0,0-5.7334,9.9267.7231.7231,0,0,0-.0654.2622h0a1.0705,1.0705,0,0,0,.2461.3238c1.1836,1.2065,2.8281,2.8486,4.4746,4.4922,1.6875,1.6845,3.377,3.3711,4.5859,4.6049a13.2117,13.2117,0,0,1,3.5274,6.5987l.0166.1133a13.9765,13.9765,0,0,1,0,4.872l-.0166.1143a13.2086,13.2086,0,0,1-3.5264,6.5976c-1.2109,1.2354-2.8994,2.9219-4.5869,4.6065-1.6465,1.6435-3.292,3.2856-4.4717,4.4892a1.0515,1.0515,0,0,0-.2509.3326h0a.8345.8345,0,0,0,.0634.2456,43.2773,43.2773,0,0,0,5.7315,9.9306.7493.7493,0,0,0,.1943.188h0a1.0845,1.0845,0,0,0,.4024-.0522c1.6513-.4243,3.9179-1.0342,6.1826-1.6426,2.2842-.6143,4.5664-1.228,6.2256-1.6548a13.2107,13.2107,0,0,1,7.4814.2451l.125.05a13.9408,13.9408,0,0,1,4.1855,2.417l.087.0689a13.2,13.2,0,0,1,3.9677,6.3667c.4659,1.6684,1.084,3.9824,1.7,6.2915.6,2.2422,1.1973,4.48,1.6485,6.1a1.0377,1.0377,0,0,0,.1621.3833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M397.0527,278.376a21.17,21.17,0,1,1,21.17-21.17A21.1938,21.1938,0,0,1,397.0527,278.376Zm0-33.47a12.3,12.3,0,1,0,12.3008,12.3A12.3145,12.3145,0,0,0,397.0527,244.9058Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuware);
export default __webpack_public_path__ + "static/media/Docuware.e3cf5db68eb694223460526dea42e4a8.svg";
export { ForwardRef as ReactComponent };